<template>
  <div>
    <!-- Basic Details -->
    <basic-details
      :matter="$store.state.matterStore.currentmatter"
    ></basic-details>
    <!-- Case Status -->
    <div v-if="hasCaseDetails">
      <case-status
        :matter="$store.state.matterStore.currentmatter"
        :detail="$store.state.matterStore.currentmatter.case_details"
      ></case-status>
    </div>
    <!-- Category -->
    <div v-if="hasCategoryDetails">
      <category-details
        :matter="$store.state.matterStore.currentmatter"
      ></category-details>
    </div>
    <!-- Linked Matters -->
    <div v-if="hasLinkedMatters">
      <linked-matters :matter="$store.state.matterStore.currentmatter"></linked-matters>
    </div>
    <!-- Peitioner & Respondent -->
    <div>
      <petitioner-respondents
        :matter="$store.state.matterStore.currentmatter"
      ></petitioner-respondents>
    </div>

    <!-- Listening History -->
    <div v-if="hasListingHistory">
      <listing-details
        :matter="$store.state.matterStore.currentmatter"
      ></listing-details>
    </div>

    <supreme-court-additional-details
      v-if="hasSupremeAdditionalDetails"
      :matter="$store.state.matterStore.currentmatter"
    ></supreme-court-additional-details>

    <b-card no-body v-if="hasLegacyCollapseSections">
      <app-collapse accordion>
        <app-collapse-item title="Notices" v-if="hasNotices">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.notices"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="Tagged Matters" v-if="hasTaggedMatters">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.tagged_matters"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="Drop Notes" v-if="hasDropNotes">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.drop_note"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="Other Documents" v-if="hasOtherDocuments">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.other_documents"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="Mention Memo" v-if="hasMentionMemo">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.mention_memo"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="Similaraties" v-if="hasSimilaraties">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.similaraties"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="Defects" v-if="hasDefects">
          <DynamicListTable
            :data="$store.state.matterStore.currentmatter.defects"
            title=""
          ></DynamicListTable>
        </app-collapse-item>
        <app-collapse-item title="IA Details" v-if="hasIaDetails">
          <CollapseListItem
            :data="$store.state.matterStore.currentmatter.ia"
          ></CollapseListItem>
        </app-collapse-item>
      </app-collapse>
    </b-card>

    <!-- IA Details -->
    <!-- <div
        v-if="Object.keys($store.state.matterStore.currentmatter).includes('ia')"
      >
        <DynamicListTable
          :data="$store.state.matterStore.currentmatter.ia"
          title="IA Details"
        ></DynamicListTable>
      </div> -->
  </div>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
// Section Imports
import BasicDetails from './components/basic-details/BasicDetails.vue'
import CaseStatus from './components/status/CaseStatus.vue'
import ListingDetails from './components/listing-history/ListingDetails.vue'
import PetitionerRespondents from './components/petitioner-respondent/PetitionerRespondents.vue'
import DynamicListTable from './components/DynamicListTable.vue'
import CategoryDetails from './components/CategoryDetails.vue'
import LinkedMatters from './components/LinkedMatters.vue'
import LowerCourt from './components/LowerCourt.vue'
import CrimeDetails from './components/CrimeDetails.vue'
import BasicTable from './components/tables/BasicTable.vue'
import SupremeCourtAdditionalDetails from './components/supreme-court/SupremeCourtAdditionalDetails.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import CollapseListItem from './components/CollapseListItem.vue'

export default {
  computed: {
    currentMatter() {
      return this.$store.state.matterStore.currentmatter || {}
    },
    hasCaseDetails() {
      const details = this.currentMatter.case_details
      return !!details && typeof details === 'object' && Object.keys(details).length > 0
    },
    hasCategoryDetails() {
      const category = this.currentMatter.category
      if (Array.isArray(category)) return category.length > 0
      return category !== null && category !== undefined && category !== ''
    },
    hasLinkedMatters() {
      return Array.isArray(this.currentMatter.linked_matters)
        ? this.currentMatter.linked_matters.length > 0
        : !!this.currentMatter.linked_matters
    },
    hasListingHistory() {
      return Array.isArray(this.currentMatter.listing_history)
        ? this.currentMatter.listing_history.length > 0
        : false
    },
    hasNotices() {
      return Array.isArray(this.currentMatter.notices)
        ? this.currentMatter.notices.length > 0
        : false
    },
    hasTaggedMatters() {
      return Array.isArray(this.currentMatter.tagged_matters)
        ? this.currentMatter.tagged_matters.length > 0
        : false
    },
    hasDropNotes() {
      return Array.isArray(this.currentMatter.drop_note)
        ? this.currentMatter.drop_note.length > 0
        : false
    },
    hasOtherDocuments() {
      return Array.isArray(this.currentMatter.other_documents)
        ? this.currentMatter.other_documents.length > 0
        : false
    },
    hasMentionMemo() {
      return Array.isArray(this.currentMatter.mention_memo)
        ? this.currentMatter.mention_memo.length > 0
        : false
    },
    hasSimilaraties() {
      return Array.isArray(this.currentMatter.similaraties)
        ? this.currentMatter.similaraties.length > 0
        : false
    },
    hasDefects() {
      return Array.isArray(this.currentMatter.defects)
        ? this.currentMatter.defects.length > 0
        : false
    },
    hasIaDetails() {
      return Array.isArray(this.currentMatter.ia)
        ? this.currentMatter.ia.length > 0
        : false
    },
    hasLegacyCollapseSections() {
      return (
        this.hasNotices ||
        this.hasTaggedMatters ||
        this.hasDropNotes ||
        this.hasOtherDocuments ||
        this.hasMentionMemo ||
        this.hasSimilaraties ||
        this.hasDefects ||
        this.hasIaDetails
      )
    },
    hasSupremeAdditionalDetails() {
      const matter = this.currentMatter
      const hasEarlierCourtDetails =
        Array.isArray(matter.earlier_court_details) &&
        matter.earlier_court_details.length > 0
      const hasListingDates =
        Array.isArray(matter.listing_dates) && matter.listing_dates.length > 0
      const hasCourtFees =
        matter.court_fees &&
        typeof matter.court_fees === 'object' &&
        !Array.isArray(matter.court_fees) &&
        Object.keys(matter.court_fees).length > 0
      const hasInterlocutoryDocs = !!matter.interlocutory_application_documents
      const hasSimilarities =
        Array.isArray(matter.similarities) && matter.similarities.length > 0
      const hasCaveat = Array.isArray(matter.caveat) && matter.caveat.length > 0

      return (
        hasEarlierCourtDetails ||
        hasListingDates ||
        hasCourtFees ||
        hasInterlocutoryDocs ||
        hasSimilarities ||
        hasCaveat
      )
    }
  },
  components: {
    BRow,
    BCard,
    BCol,
    // Basic Details
    BasicDetails,
    CaseStatus,
    ListingDetails,
    PetitionerRespondents,
    DynamicListTable,
    CategoryDetails,
    LinkedMatters,
    LowerCourt,
    CrimeDetails,
    BasicTable,
    SupremeCourtAdditionalDetails,
    AppCollapse,
    AppCollapseItem,
    CollapseListItem
  }
}
</script>
